import(/* webpackMode: "eager", webpackExports: ["SearchResultsPage"] */ "/workspace/libs/ui-components/src/lib/SearchResultsPage/SearchResultsPage.tsx");
